import { topicCategoryRepository } from "../../../providers/repositories/topicCategoryRepository";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const deleteTopicCategoryUseCase = {
    async exec(id: string | number): Promise<boolean> {
        try {
            await topicCategoryRepository.delete(id);
            toast.success(t("action.deleteSuccess"));
            return true;
        } catch (error) {
            Logger.error("deleteTopicCategoryUseCase", error);
            toast.error(t("action.deleteError"));
        }
        return false;
    },
};
